import { audioRunning, ring } from "@/lib/push";

const ON_KEY = "fsc_order_sound";
const VOL_KEY = "fsc_order_volume";
const LAST_KEY = "fsc_order_rang_at";
const RUNG_KEY = "fsc_order_rung";
export const VOLUMES = [["0.35", "Baixo", "baixo"], ["0.65", "Médio", "medio"], ["1", "Alto", "alto"]];

export const isOrderSound = () => localStorage.getItem(ON_KEY) !== "0";
export const setOrderSound = (on) => { localStorage.setItem(ON_KEY, on ? "1" : "0"); window.dispatchEvent(new Event("fsc-sound")); };
export const orderVolume = () => localStorage.getItem(VOL_KEY) || "1";
export const setOrderVolume = (v) => localStorage.setItem(VOL_KEY, v);
export const soundReady = () => isOrderSound() && audioRunning();
export const playOrder = (kind = "pedido") => ring(kind, Number(orderVolume()));

const rung = () => { try { return JSON.parse(localStorage.getItem(RUNG_KEY) || "[]"); } catch { return []; } };

// Pedido aguardando aceite toca a cada checagem; pedido de garçom/aceito sozinho toca uma vez. Trava entre abas.
export function alertFor({ pending, news }) {
  const seen = rung();
  const fresh = news.filter((n) => !seen.includes(n.id)).map((n) => n.id);
  if (fresh.length) localStorage.setItem(RUNG_KEY, JSON.stringify([...seen, ...fresh].slice(-100)));
  if (!pending.length && !fresh.length) return;
  if (Date.now() - Number(localStorage.getItem(LAST_KEY) || 0) < 8000) return;
  localStorage.setItem(LAST_KEY, String(Date.now()));
  playOrder(pending.length ? "pedido" : "garcom");
}
